import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private readonly translateService = inject(TranslateService);
  private readonly title = inject(Title);

  constructor() {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      if (title.startsWith('ROUTE_TITLES.')) {
        // Use instant() — synchronous, no subscription leak
        this.title.setTitle(this.translateService.instant(title));
      } else {
        this.title.setTitle(title);
      }
    }
  }
}
